import { Directive, Input, TemplateRef } from '@angular/core';

import { Select2Item, ItemContext } from '../../types';

@Directive({
  standalone: true,
  selector: '[rtSelectListItem]',
  exportAs: 'listItemDir',
})
export class Select2ListItemDirective<T> {
  public static ngTemplateContextGuard<T>(
    dir: Select2ListItemDirective<T>,
    ctx: unknown,
  ): ctx is T extends { items: Select2Item[] } ? ItemContext<T['items'][0]> : ItemContext<any> {
    return true;
  }
  @Input({ required: true }) public rtSelectListItem: T;

  constructor(public templateRef: TemplateRef<ItemContext<T>>) {}
}
